export default __webpack_public_path__ + "static/media/Group470@2x.6b4f637f.png";